import React, { useState } from "react";
import PropTypes from "prop-types";

import t from "../../../lib/translate";
import { generateClassString as gcs } from "../../../lib/helper/generateClassString";

import * as styles from "./photoCredits.module.less";

function PhotoCredit({ items = [] }) {
    const [show, setShow] = useState(false);

    if (items.length === 0) {
        return null;
    }

    return (
        <>
            <button
                className={gcs(styles.pictureCreditsButton, [
                    show,
                    styles.btnActive
                ])}
                onClick={() => setShow(!show)}
            >
                {t("page.footer.pictureCredits")}
            </button>

            <div className={gcs(styles.pictureCredits, [show, styles.show])}>
                <span>{t("page.footer.pictureCredits")}</span>
                {items.map(({ author, copyright }) => (
                    <span>
                        {copyright} {author && `/ ${author}`}
                    </span>
                ))}
            </div>
        </>
    );
}

PhotoCredit.defaultProps = {
    items: []
};

PhotoCredit.propTypes = {
    items: PropTypes.arrayOf(
        PropTypes.shape({
            copyright: PropTypes.string.isRequired
        })
    )
};

export { PhotoCredit };
